// 三级页面
<template>
  <div class="page">
    <!-- 背景视频 -->
    <video v-if="type==='xl'" class="video-background" id="bgVideo" autoplay muted loop>
      <source src="../../assets/bg2.mp4" type="video/mp4">
      <!-- <source src="https://s1.xiaomiev.com/activity-outer-assets/0328/images/Ultra_U/pc/ultra_2_1.mp4" type="video/mp4"> -->
      您的浏览器不支持视频标签。
    </video>
    <div class="container">
      <ul class="flx-cc btnBox progressBox" v-if="type==='wl' && point=='2'">
        <li v-for="item in list2" :key="item.name" class="btn" @click="$router.push('/info?type=wl&device='+item.name)">{{item.name}}</li>
      </ul>
      <div v-if="type==='xl'" ref="threeContainer" @click="onClick" class="model" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0,0,0,0)"></div>
      <div v-else-if="type==='wl' && point=='2'" class="viewer">
        <!-- 将下面的 src 替换为 720云实际提供的嵌入链接 -->
        <iframe 
          :src="jsonData.detail.two.bg" 
          width="100%" 
          height="100%" 
          frameborder="0" 
          allowfullscreen>
        </iframe>
      </div>
      <div v-else class="images">
        <img :src="imgSrc"/>
      </div>
      
      <!-- 1号和2号工厂上下结构 -->
      <div v-if="point=='1' || point=='2'" class="top_bottom">
        <div class="action">
          <div v-if="type==='wl'" class="action_btn" @click="$router.go(-1)">返回</div>
        </div>
        <!-- 虚拟工厂内容 -->
        <div class="flx-bc page_bottom" v-if="type=='xl'">
          <div class="action" style="position:initial">
            <!-- 虚拟模型操作 -->
            <div class="action_box action_box3">
              <!-- <div class="flx-bc line line1">
                <div class="item" @click="doModel('rotate','left')">左旋</div>
                <div class="item" @click="doModel('rotate','right')">右旋</div>
              </div>
              <div class="flx-bc line">
                <div class="item" @click="doModel('scale','big')">放大</div>
                <div class="item" @click="doModel('scale','small')">缩小</div>
              </div> -->
              <div class="line" @click="$router.go(-1)">返回</div>
              <div class="line" @click="$router.push('/index')">返回首页</div>
              <div class="line" @click="doModel('reset')">复位</div>
              <div class="flx-bc line">
                <div class="item" @click="doModel('change','1F')">1F</div>
                <div class="item" @click="doModel('change','2F')">2F</div>
              </div>
              <div class="line" @click="doModel('gylc')">工艺流程</div>
            </div>
          </div>
          <!-- <div class="box box_l1">
            <h3 class="title">工厂概况</h3>
            <div class="info">
              <div class="intro">
                <p>工厂依托京东方数字化优势，打通采购、生产、研发等系统孤岛，实现设备互联、生产透明及 AI 辅助决策。</p>
                <p>新建车间含 1 条数字化酪蛋白生产线，配套环保设施，年产 3000 吨，完善“牧区原料 - 精深加工 - 市场” 产业链，带动牧民增收。</p>
                <p>二楼设数字展示中心，大屏呈现车间实时数据，搭互动平台，整合产学研资源，助力科普、市场对接与产业创新。</p>
              </div>
            </div>
          </div> -->
          <div class="box box_l2">
            <h3 class="title">能耗统计</h3>
            <div class="main">
              <!-- <img src="/assets/image/detail/nhtj.png" /> -->
              <div class="chart" id="nhtj"></div>
            </div>
          </div>
          <div class="box box_l2">
            <h3 class="title">设备监测</h3>
            <div class="main">
              <img src="/assets/image/detail/sbjc.png" />
              <div class="device" :class="'device'+index" v-for="(item,index) in jsonData.detail.sbjc" :key="index"><span>{{item.value}}</span></div>
            </div>
          </div>
          <div class="box box_l2">
            <h3 class="title">报警信息</h3>
            <div class="main bjxx">
              <img src="/assets/image/detail/bjxx.png" />
              <div class="viewer" :class="'viewer'+index" v-for="(item,index) in jsonData.detail.bjxx" :key="index"><span>{{item.value}}</span><p>{{item.name}}</p></div>
            </div>
          </div>
          <div class="box box_l2">
            <h3 class="title">监控视频</h3>
            <div class="main">
              <video v-if="videoUrl" :src="videoUrl" controls class="video">
                Your browser does not support the video tag.
              </video>
              <img v-else src="/assets/image/detail/jksp.png" />
            </div>
          </div>
        </div>
        <!-- 物理工厂内容 -->
        <div class="flx-bc page_bottom" v-else>
          <div class="box box_l1">
            <h3 class="title">订单信息</h3>
             <div class="main">
              <!-- <img :src="point==='1'?'/assets/image/detail/1/ddxx.png':'/assets/image/detail/2/ddxx.png'" /> -->
              <div class="table" v-if="jsonData.detail">
                <table>
                  <tr>
                    <th>产品名称</th>
                    <th>下单时间</th>
                    <th>订单编号</th>
                    <th>订单金额</th>
                    <th>订单状态</th>
                  </tr>
                  <tbody v-if="point==='1'">
                    <tr v-for="(item,index) in jsonData.detail.one.ddxx" :key="index">
                      <td>{{item.name}}</td>
                      <td>{{item.time}}</td>
                      <td>{{item.code}}</td>
                      <td>{{item.price}}</td>
                      <td>{{item.status}}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr v-for="(item,index) in jsonData.detail.two.ddxx" :key="index">
                      <td>{{item.name}}</td>
                      <td>{{item.time}}</td>
                      <td>{{item.code}}</td>
                      <td>{{item.price}}</td>
                      <td>{{item.status}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="box box_l2">
            <h3 class="title">原料数据</h3>
             <div class="main">
              <!-- <img :src="point==='1'?'/assets/image/detail/1/ylsj.png':'/assets/image/detail/2/ylsj.png'" /> -->
              <div v-if="point==='1'" class="chart" id="one_ylsj"></div>
              <div v-else class="chart" id="two_ylsj"></div>
            </div>
          </div>
          <div class="box box_l2">
            <h3 class="title">库存数据</h3>
             <div class="main">
              <!-- <img :src="point==='1'?'/assets/image/detail/1/kcsj.png':'/assets/image/detail/2/kcsj.png'" /> -->
              <div v-if="point==='1'" class="chart" id="one_kcsj"></div>
              <div v-else class="chart" id="two_kcsj"></div>
            </div>
          </div>
          <div class="box box_l2">
            <h3 class="title">产量数据</h3>
             <div class="main">
              <!-- <img :src="point==='1'?'/assets/image/detail/1/clsj.png':'/assets/image/detail/2/clsj.png'" /> -->
              <div v-if="point==='1'" class="chart" id="one_clsj"></div>
              <div v-else class="chart" id="two_clsj"></div>
            </div>
          </div>
          <div class="box box_l2">
            <h3 class="title">销售数据</h3>
             <div class="main">
              <!-- <img :src="point==='1'?'/assets/image/detail/1/xssj.png':'/assets/image/detail/2/xssj.png'" /> -->
              <div v-if="point==='1'" class="chart" id="one_xssj"></div>
              <div v-else class="chart" id="two_xssj"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 其他左右结构 -->
      <div v-else class="left_right">
        <div class="page_left">
          <div class="box box_l1" v-if="point=='szzx'">
            <h3 class="title">赋能中心介绍</h3>
            <div class="info">
              <div class="intro" v-if="jsonData.detail"><p v-for="(item,index) in jsonData.detail.szzx.fnzxjs" :key="index">{{item}}</p></div>
            </div>
          </div>
          <div class="box box_l2" v-if="point=='szzx'">
            <h3 class="title">参观接待</h3>
            <div class="main" v-if="jsonData.detail">
              <swiper :options="swiperOptionCgjd" ref="mySwiperCgjd" class="swiper" v-if="jsonData.detail.szzx.cgjd.length>1">
                  <!-- slides -->
                  <swiper-slide v-for="(item, index) in jsonData.detail.szzx.cgjd" :key="index">
                    <el-image 
                      style="width: 100%; height: 100%"
                      :src="item.url" 
                      :preview-src-list="previewList">
                    </el-image>   
                  </swiper-slide>
                  <!-- Optional controls -->
                  <div class="swiper-pagination swiper-pagination-cgjd" slot="pagination"></div>
                  <div class="swiper-button-prev swiper-button-prev-cgjd" slot="button-prev"></div>
                  <div class="swiper-button-next swiper-button-next-cgjd" slot="button-next"></div>
              </swiper>
              <el-image v-if="jsonData.detail.szzx.cgjd.length===1"
                style="width: 100%; height: 100%"
                :src="jsonData.detail.szzx.cgjd[0].url" 
                :preview-src-list="previewList">
              </el-image>   
            </div>
          </div>
          <div class="box box_l1 box_kxjy1" v-if="point=='kjxy'">
            <h3 class="title">小院介绍</h3>
            <div class="info">
              <div class="intro" v-if="jsonData.detail"><p v-for="(item,index) in jsonData.detail.kjxy.xyjs" :key="index">{{item}}</p></div>
            </div>
          </div>
          <div class="box box_l1" v-if="point=='dlcj'">
            <h3 class="title">车间介绍</h3>
            <div class="info">
              <div class="intro" v-if="jsonData.detail"><p v-for="(item,index) in jsonData.detail.dlcj.cjjs" :key="index">{{item}}</p></div>
            </div> 
          </div>
          <div class="box box_r3" v-if="point=='kjxy'">
            <h3 class="title title2">证书</h3>
            <div class="main" v-if="jsonData.detail.kjxy">
              <swiper :options="swiperOptionZs" ref="mySwiperZs" class="swiper" v-if="jsonData.detail.kjxy.zs.length>1">
                  <!-- slides -->
                  <swiper-slide v-for="(item, index) in jsonData.detail.kjxy.zs" :key="index">
                    <el-image 
                      style="width: 100%; height: 100%"
                      :src="item.url" 
                      :preview-src-list="previewList">
                    </el-image>                 
                  </swiper-slide>
                  <!-- Optional controls -->
                  <div class="swiper-pagination swiper-pagination-zs" slot="pagination"></div>
                  <div class="swiper-button-prev swiper-button-prev-zs" slot="button-prev"></div>
                  <div class="swiper-button-next swiper-button-next-zs" slot="button-next"></div>
              </swiper>
              <el-image v-if="jsonData.detail.kjxy.zs.length===1"
                style="width: 100%; height: 100%"
                :src="jsonData.detail.kjxy.zs[0].url" 
                :preview-src-list="previewList">
              </el-image>  
            </div>
          </div>
          <div class="box box_l2" v-if="point=='dlcj'">
            <h3 class="title">设备运行情况</h3>
            <div class="main" v-if="jsonData.detail">
              <img src="/assets/image/detail/dlcj/sbyx.png" />
              <div class="device" :class="'device'+index" v-for="(item,index) in jsonData.detail.dlcj.sbyxqk" :key="index"><span>{{item.value}}</span></div>
            </div>
          </div>
          <!-- <div class="action">
            <div class="action_box action_box2" v-if="actionShow">
              <div class="line" @click="$router.go(-1)">返回</div>
              <div class="line" @click="$router.push('/index')">返回首页</div>
            </div>
            <div class="action_btn" @click="actionShow=!actionShow">操作按钮</div>
          </div> -->
          <div class="action">
            <div class="action_btn" @click="$router.go(-1)">返回</div>
          </div>
        </div>
        <div class="page_right">
          <div class="box box_zj" v-if="point=='kjxy'">
            <h3 class="title">专家信息</h3>
            <div class="main" v-if="jsonData.detail">
              <div class="flx-bc photos">
                <div class="item" :class="index===sliderIndex?'active':''" v-for="(item, index) in jsonData.detail.kjxy.zjxx" :key="index"><img :src="item.photo"></div>
              </div>
              <swiper :options="swiperOptionZj" ref="swiperZj" class="swiper"  v-if="jsonData.detail.kjxy.zjxx.length>1" @slide-change="onSlideChange">
                  <!-- slides -->
                  <swiper-slide v-for="(item, index) in jsonData.detail.kjxy.zjxx" :key="index">
                    <div class="content">
                      <span>{{item.name}}</span>，{{item.info}}
                    </div>
                  </swiper-slide>
                  <!-- Optional controls -->
                  <!-- <div class="swiper-pagination" slot="pagination"></div> -->
                  <div class="swiper-button-prev swiper-button-prev-zj" slot="button-prev"></div>
                  <div class="swiper-button-next swiper-button-next-zj" slot="button-next"></div>
              </swiper>
              <img :src="jsonData.detail.kjxy.zjxx[0]" v-else>
            </div>
          </div>
          <div class="box box_r1" v-if="point==='szzx' || point==='dlcj'">
            <h3 class="title">能耗统计</h3>
            <div class="main">
              <!-- <img src="/assets/image/detail/szzx/nhtj.png" /> -->
              <div v-if="point==='szzx'" class="chart" id="szzx_nhtj"></div>
              <div v-if="point==='dlcj'" class="chart" id="dlcj_nhtj"></div>
            </div>
          </div>
          <div class="box box_r3" v-if="point==='szzx'">
            <h3 class="title">接待数据</h3>
            <div class="main">
              <!-- <img src="/assets/image/detail/szzx/jdsj.png" /> -->
              <div class="chart" id="jdsj"></div>
            </div>
          </div>
          <div class="box box_r2" v-if="point==='dlcj'">
            <h3 class="title">环境监测</h3>
            <div class="main" v-if="jsonData.detail">
              <img src="/assets/image/detail/dlcj/hjjc.png" />
              <div class="viewer" :class="'viewer'+index" v-for="(item,index) in jsonData.detail.dlcj.hjjc" :key="index"><span>{{item.value}}</span><p>{{item.name}}</p></div>
            </div>
          </div>
          <div class="box box_r3" v-if="point!='kjxy'">
            <h3 class="title">监控视频</h3>
            <div class="main">
              <video v-if="videoUrl" :src="videoUrl" controls class="video">
                Your browser does not support the video tag.
              </video>
              <img v-else src="/assets/image/detail/szzx/jksp.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul class="flx-cc btnBox techBox" v-if="point=='kjxy'">
      <li class="btn" @click="doTechnology('yfzx')">成都酪蛋白生物产学研中心</li>
      <li class="flx-lc btn" @click="doTechnology('bscx')"><span>炉霍</span><div><p>酪蛋白生物</p><p>高原功能性食品  联合实验室</p></div></li>
    </ul>
    <gylc v-if="gylcShow" :visible.sync="gylcShow" type="model"></gylc>
    <div class="fullVideo" v-if="kjsVideo">
      <video autoplay controls :src="kjsVideo" :key="kjsVideo" @ended="playEnd"></video>
    </div>
  </div>
</template>

<script>
// 引入 Three.js 核心
import * as THREE from 'three';
// 注意：从 three/examples/jsm/ 路径引入
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
// 如果需要轨道控制器
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
// 环境贴图
import { DebugEnvironment } from 'three/examples/jsm/environments/DebugEnvironment.js';

import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass';


import gylc from '../index/gylc.vue'

import axios from 'axios'
import echarts from 'echarts'
export default {
  name: 'My3DComponent',
  components: {swiper, swiperSlide,gylc},
  data() {
    return {
      type: '',
      point: '', //科技小院，1号工厂，2号工厂，数智中心，动力车间
      actionShow: false,
      loading: false,
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      animationId: null,
      lastRender: 0, //模型渲染
      mixer: null,
      model:null,
      scale: 1,
      rotationY: - Math.PI / 2,
      clickableObjects: [], //可点击的对象模型
      imgSrc: '',
      swiperOptionCgjd: {
          loop: true,
          autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false
          },
          // 显示分页
          pagination: {
              el: ".swiper-pagination-cgjd",
              clickable: true //允许分页点击跳转
          },
          // 设置点击箭头
          navigation: {
              nextEl: ".swiper-button-next-cgjd",
              prevEl: ".swiper-button-prev-cgjd"
          },
          observer: true,
          observeParents: true
      },
      swiperOptionZj: {
          loop: true,
          autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false
          },
          // 显示分页
          pagination: {
              el: ".swiper-pagination-zj",
              clickable: true //允许分页点击跳转
          },
          // 设置点击箭头
          navigation: {
              nextEl: ".swiper-button-next-zj",
              prevEl: ".swiper-button-prev-zj"
          },
          observer: true,
          observeParents: true
      },
      swiperOptionZs: {
          loop: true,
          autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false
          },
          // 显示分页
          pagination: {
              el: ".swiper-pagination-zs",
              clickable: true //允许分页点击跳转
          },
          // 设置点击箭头
          navigation: {
              nextEl: ".swiper-button-next-zs",
              prevEl: ".swiper-button-prev-zs"
          },
          observer: true,
          observeParents: true
      },
      sliderIndex: 0,
      loft: 1, //虚拟模型楼层
      gylcShow: false,
      outlinePass : null,
      composer: null,
      list2: [{
                name: '原料粉碎',
            },{
                name: '螺旋输送机',
            },{
                name: '溶解罐',
            },{
                name: '净乳机',
            },{
                name: '缓冲罐',
            },{
                name: '脱脂机',
            },{
                name: '灭菌机',
            },{
                name: '凝乳罐',
            },{
                name: '压滤机',
            },{
                name: '湿法破碎机',
            },{
                name: '干燥塔',
            },{
                name: '粉碎机组',
            },{
                name: '混料机',
            },{
                name: '自动包装机',
            }],

      jsonData: {detail:''},
      videoUrl: '',
      kjsType: '',
      kjsVideo: '', //科技树播放视频
      previewList: []
    };
  },
  created() {
    this.type = this.$route.query.type
    this.point = this.$route.query.point
    if(this.type==='xl'){
      this.getData('modelXl')
    }else{
      this.getData('modelWl')
    }
  },
  mounted() {
    if(this.type === 'xl'){
      this.loading = true
      // // 延迟 100ms 等待旧 context 回收
      setTimeout(() => {
        this.initThree();
        this.loadModel();
        this.animate();
        window.addEventListener('resize', this.onWindowResize);
      }, 100);
    }
  },
  beforeDestroy() {
    // 清理 Three.js 资源，防止内存泄漏
    this.cleanUp();
  },
  methods: {
    doTechnology(type){
      this.kjsType = type
      this.kjsVideo = type=='yfzx'?'/assets/image/kjxy/yfzx.mp4':'/assets/image/kjxy/bscx.mp4'
    },
    playEnd(){
      console.log("视频播放结束")
      setTimeout(() => {
        this.$router.push('/technology?type='+this.kjsType)
      },500)
    },
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          this.jsonData = res.data.data
          if(this.type === 'xl'){
            this.videoUrl = this.jsonData.detail.jksp
            this.$nextTick(() => {
                this.echarts('nhtj')
            })
          }else{
            this.jsonData.detail.kjxy.xyjs = this.jsonData.detail.kjxy.xyjs.split('\n')
            this.jsonData.detail.szzx.fnzxjs = this.jsonData.detail.szzx.fnzxjs.split('\n')
            this.jsonData.detail.dlcj.cjjs = this.jsonData.detail.dlcj.cjjs.split('\n')
            switch(this.point){
              case '1':
                this.imgSrc = this.jsonData.detail.one.bg
                this.$nextTick(() => {
                    this.echartsH('one_ylsj')
                    this.echarts('one_kcsj')
                    this.echartsH('one_clsj')
                    this.echartsH('one_xssj')
                })
                break;
              case '2':
                this.imgSrc = this.jsonData.detail.two.bg
                this.$nextTick(() => {
                    this.echartsH('two_ylsj')
                    this.echarts('two_kcsj')
                    this.echartsH('two_clsj')
                    this.echartsH('two_xssj')
                })
                break;
              case 'kjxy':
                this.imgSrc = this.jsonData.detail.kjxy.bg
                this.videoUrl = this.jsonData.detail.kjxy.jksp
                this.previewList = this.jsonData.detail.kjxy.zs.map(it => it.url)
                break;
              case 'szzx':
                this.imgSrc = this.jsonData.detail.szzx.bg
                this.videoUrl = this.jsonData.detail.szzx.jksp
                this.previewList = this.jsonData.detail.szzx.cgjd.map(it => it.url)
                this.$nextTick(() => {
                  this.echarts('szzx_nhtj')
                  this.echartsOne('jdsj')
                })
                break;
              case 'dlcj':
                this.imgSrc = this.jsonData.detail.dlcj.bg
                this.videoUrl = this.jsonData.detail.dlcj.jksp
                this.$nextTick(() => {
                    this.echarts('dlcj_nhtj')
                })
                break;
            }
          }
        }
      })
    },
    echarts(type){
        var chart = null
        let datas = []
        let dataX = []
        let names = []
        let chartData = []
        if(type==='nhtj'){
            chart = echarts.init(document.getElementById('nhtj'));
            chartData = this.jsonData.detail.nhtj
        }else if(type==='szzx_nhtj'){
            chart = echarts.init(document.getElementById('szzx_nhtj'));
            chartData = this.jsonData.detail.szzx.nhtj
        }else if(type==='dlcj_nhtj'){
            chart = echarts.init(document.getElementById('dlcj_nhtj'));
            chartData = this.jsonData.detail.dlcj.nhtj
        }else if(type==='one_kcsj'){
            chart = echarts.init(document.getElementById('one_kcsj'));
            chartData = this.jsonData.detail.one.kcsj
        }else if(type==='two_kcsj'){
            chart = echarts.init(document.getElementById('two_kcsj'));
            chartData = this.jsonData.detail.two.kcsj
        }
        dataX = chartData[0].data.map(it => it.name)
        names = chartData.map(it => it.name)
        chartData.forEach(item => {
            let data = item.data.map(it => it.value)
            datas.push({
                data: data,
                name: item.name,
                type: 'bar',
                barWidth: 20,
                label: {
                    show: true,                    // 显示标签
                    position: 'top',               // 标签显示在柱子顶部
                    fontSize: 30,
                    color: '#fff',                 // 数值颜色
                    fontWeight: 'bold',
                    // 可选：格式化显示内容
                    formatter: '{c}',// {c} 表示数值，{a}系列名，{b}类目名
                },
            })
        });
        // 清空图表
        chart.clear();
        chart.setOption({
            // 设置绘图区域的边距
            grid: {
                left: 40,   // 左侧距离
                right: 80,  // 右侧距离
                top: 100,   // 可选：顶部距离
                bottom: 40, // 可选：底部距离
                containLabel: true // 确保标签不被裁剪
            },
            legend: {
                top: 30,
                data: names,
                textStyle: {
                    fontSize: 24,
                    color: '#fff',
                    padding:[0,10],
                },
            },
            tooltip: {
                trigger: 'item',
                textStyle: {
                    color: '#fff',
                    fontSize: 24,
                },
            },
            color: ['#085ba9','#33b2e9','#33e933','#AECDFF','#FF510C','#0C85FF'],
            xAxis: {
                type: 'category',
                data: dataX,
                axisTick: {
                    show: false
                },
                axisLine: {
                  show: true,
                    lineStyle: {
                      color: '#274c8e', // 设置 x 轴线的颜色
                    }
                },
                boundaryGap: false, // 去掉左右两边的空白
                axisLabel: {
                    color: '#fff', // 文字颜色
                    fontSize: 24,   // 字体大小
                    margin: 24,
                    // rotate: 45
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                  show: true,
                    lineStyle: {
                      color: '#274c8e', // 设置 x 轴线的颜色
                    }
                },
                splitLine: { 
                    lineStyle: {
                        color: '#274c8e', // 设置 x 轴线的颜色
                    } 
                },
                axisTick: { show: false },
                axisLabel: {
                    color: '#fff', // 文字颜色
                    fontSize: 24,   // 字体大小
                    margin: 60,
                    formatter: '{value}'
                }
            },
            series: datas,
        })
    },
    echartsOne(type){
      var chart = null
      let dataX = []
      let dataY = []
      if(type==='jdsj'){
        chart = echarts.init(document.getElementById('jdsj'));
        dataX = this.jsonData.detail.szzx.jdsj.map(it => {
          return it.name
        })
        dataY = this.jsonData.detail.szzx.jdsj.map(it => {
          return it.value
        })
      }else if(type==='one_ylsj'){
        chart = echarts.init(document.getElementById('one_ylsj'));
        dataX = this.jsonData.detail.one.ylsj.data.map(it => {
          return it.name
        })
        dataY = this.jsonData.detail.one.ylsj.data.map(it => {
          return it.value
        })
      }else if(type==='two_ylsj'){
        chart = echarts.init(document.getElementById('two_ylsj'));
        dataX = this.jsonData.detail.two.ylsj.data.map(it => {
          return it.name
        })
        dataY = this.jsonData.detail.two.ylsj.data.map(it => {
          return it.value
        })
      }
      // 清空图表
      chart.clear();
      chart.setOption({
        // 设置绘图区域的边距
        grid: {
            left: 40,   // 左侧距离
            right: 80,  // 右侧距离
            top: 100,   // 可选：顶部距离
            bottom: 40, // 可选：底部距离
            containLabel: true // 确保标签不被裁剪
        },
        tooltip: {
            trigger: 'item',
            textStyle: {
                color: '#fff',
                fontSize: 24,
            },
        },
        xAxis: {
          type: 'category',
          data: dataX,
          axisLabel: {
            color: '#fff',
            fontSize: 24,
            margin: 24
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            data: dataY,
            type: 'bar',
            barWidth: 20,
            itemStyle: {
              normal: {
                color: function(params) {
                    var colorList = [
                        new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                              { offset: 0, color: '#e0f7ff' },     // 底部深色
                              { offset: 0.3, color: '#00a6d6' },   // 中间
                              { offset: 1, color: '#003f5c' }      // 顶部浅色
                            ]
                        )
                    ];
                    return colorList[params.dataIndex];
                }
              }
            },
            label: {
              normal: {
                  show: true,
                  position: 'top',
                  formatter: '{c}人',
                  color: 'white',
                  fontSize: 24,
              }
            }
          }
        ]
      })
    },
    echartsH(type){
      var chart = null
      let dataX = []
      let dataY = []
      let unit = ''
      let maxValue = ''; // X轴最大值，也是背景条长度
      var backgroundData = []
      if(type==='one_ylsj'){
        chart = echarts.init(document.getElementById('one_ylsj'));
        unit = this.jsonData.detail.one.ylsj.unit
        maxValue = this.jsonData.detail.one.ylsj.max
        dataX = this.jsonData.detail.one.ylsj.data.map(it => {
          return it.name
        })
        dataY = this.jsonData.detail.one.ylsj.data.map(it => {
          return it.value
        })
        backgroundData = this.jsonData.detail.one.ylsj.data.map(() => maxValue);
      }else if(type==='one_clsj'){
        chart = echarts.init(document.getElementById('one_clsj'));
        unit = this.jsonData.detail.one.clsj.unit
        // maxValue = this.jsonData.detail.one.clsj.max
        dataX = this.jsonData.detail.one.clsj.data.map(it => {
          return it.name
        })
        dataY = this.jsonData.detail.one.clsj.data.map(it => {
          return it.value
        })
        backgroundData = this.jsonData.detail.one.clsj.data.map(() => maxValue);
      }else if(type==='one_xssj'){
        chart = echarts.init(document.getElementById('one_xssj'));
        unit = this.jsonData.detail.one.xssj.unit
        maxValue = this.jsonData.detail.one.xssj.max
        dataX = this.jsonData.detail.one.xssj.data.map(it => {
          return it.name
        })
        dataY = this.jsonData.detail.one.xssj.data.map(it => {
          return it.value
        })
        backgroundData = this.jsonData.detail.one.xssj.data.map(() => maxValue);
      }else if(type==='two_ylsj'){
        chart = echarts.init(document.getElementById('two_ylsj'));
        unit = this.jsonData.detail.two.ylsj.unit
        maxValue = this.jsonData.detail.two.ylsj.max
        dataX = this.jsonData.detail.two.ylsj.data.map(it => {
          return it.name
        })
        dataY = this.jsonData.detail.two.ylsj.data.map(it => {
          return it.value
        })
        backgroundData = this.jsonData.detail.two.ylsj.data.map(() => maxValue);
      }else if(type==='two_clsj'){
        chart = echarts.init(document.getElementById('two_clsj'));
        unit = this.jsonData.detail.two.clsj.unit
        // maxValue = this.jsonData.detail.two.clsj.max
        dataX = this.jsonData.detail.two.clsj.data.map(it => {
          return it.name
        })
        dataY = this.jsonData.detail.two.clsj.data.map(it => {
          return it.value
        })
        backgroundData = this.jsonData.detail.two.clsj.data.map(() => maxValue);
      }else if(type==='two_xssj'){
        chart = echarts.init(document.getElementById('two_xssj'));
        unit = this.jsonData.detail.two.xssj.unit
        maxValue = this.jsonData.detail.two.xssj.max
        dataX = this.jsonData.detail.two.xssj.data.map(it => {
          return it.name
        })
        dataY = this.jsonData.detail.two.xssj.data.map(it => {
          return it.value
        })
        backgroundData = this.jsonData.detail.two.xssj.data.map(() => maxValue);
      }
      // 清空图表
      chart.clear();
      chart.setOption({
        // 设置绘图区域的边距
        grid: {
            left: 40,   // 左侧距离
            right: 80,  // 右侧距离
            top: 100,   // 可选：顶部距离
            bottom: 40, // 可选：底部距离
            containLabel: true // 确保标签不被裁剪
        },
        tooltip: {
            trigger: 'item',
            textStyle: {
                color: '#fff',
                fontSize: 24,
            },
            formatter: function(params) {
              if (params.seriesName === '背景') return ''; // 隐藏背景条 tooltip
              return params.name + ': ' + params.value;
            }
        },
        xAxis: maxValue ?{
          type: 'value',
          boundaryGap: [0, 0], // 确保从原点开始
          show: false,
          max: maxValue
        }:{
          type: 'value',
          boundaryGap: [0, 0], // 确保从原点开始
          show: false,
        },
        yAxis: {
          type: 'category',
          data: dataX,
          axisLabel: {
            color: '#fff',
            fontSize: 24,
            margin: 24
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [
          // 背景条系列（底层）
          {
            name: '背景',
            type: 'bar',
            barWidth: 20,
            barGap: '-100%', // 强制背景条与数据条重叠
            silent: true, // 禁用交互
            itemStyle: {
              normal: {
                color: 'rgba(0, 0, 0, 0.2)' // 浅白半透明背景
              }
            },
            data: backgroundData
          },
          {
            data: dataY,
            type: 'bar',
            barWidth: 20,
            itemStyle: {
              normal: {
                barBorderRadius: 0, // 去掉圆角
                color: function(params) {
                  // 根据索引设置不同颜色
                  var colors = type==='one_clsj'||type==='two_clsj'?['#e74c3c', '#f39c12', '#f1c40f', '#2ecc71', '#3498db', '#9b59b6', '#1abc9c']:
                      type==='one_ylsj'||type==='two_ylsj'?[
                        new echarts.graphic.LinearGradient(
                            0, 0, 1, 0, // 渐变方向：从左到右
                            [
                              { offset: 0, color: '#49b5f6' },    
                              { offset: 0.3, color: '#6ec5d8' }, 
                              { offset: 1, color: '#f8e96c' } 
                            ]
                          )
                      ]:[
                        new echarts.graphic.LinearGradient(
                            0, 0, 1, 0, // 渐变方向：从左到右
                            [
                              { offset: 0, color: '#1e87bd' }, 
                              { offset: 1, color: '#065ee1' }    
                            ]
                          )
                      ];
                  return colors[params.dataIndex];
                }
              }
            },
            label: {
              normal: {
                  show: true,
                  position: 'right',
                  formatter: '{c}'+unit,
                  color: 'white',
                  fontSize: 24,
              }
            }
          }
        ]
      })
    },
    onSlideChange(){
      const swiper = this.$refs.swiperZj.swiper
      if (swiper) {
        this.sliderIndex = swiper.realIndex
      }
    },
    // 旋转，翻转模型
    doModel(type,value){
      // 原始大小
      let obj = {
        scale: this.loft===1?0.4:0.18,
        rotationY: - Math.PI / 2
      }
      if(type === 'scale'){
        if(value==='big'){
          this.scale += 0.1
        }else{
          this.scale -= 0.1
        }
        this.model.scale.set(obj.scale*this.scale, obj.scale*this.scale, obj.scale*this.scale);
      }else if(type === 'rotate'){
        if(value==='left'){
          this.rotationY -= Math.PI / 2
        }else{
          this.rotationY += Math.PI / 2
        }
        this.model.rotation.y = this.rotationY;
      }else if(type === 'reset'){
        this.model.rotation.y = obj.rotationY;
        this.model.scale.set(obj.scale, obj.scale, obj.scale);
        this.controls.reset();
      }else if(type === 'change'){
        if(value==='1F'){
          if(this.loft===1) return
          this.loft=1
          this.disposeModel(this.model)
          this.loadModel()
          this.doModel('reset')
        }else{
          if(this.loft===2) return
          this.loft=2
          this.disposeModel(this.model)
          this.loadModel()
        }
      }else if(type === 'gylc'){
        this.gylcShow = true
      }
    },
    initThree() {
      // 创建场景
      this.scene = new THREE.Scene();
      // this.scene.background = new THREE.Color(0xffffff);
      this.scene.background = null; // 设置场景背景透明

      // 创建相机
      const width = this.$refs.threeContainer.offsetWidth;
      const height = this.$refs.threeContainer.offsetHeight;
      this.camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
      this.scene.add(this.camera);//将相机加入到场景中
      this.camera.position.z = 10;

      // 创建渲染器
      this.renderer = new THREE.WebGLRenderer({ antialias: true,alpha: true });
      this.renderer.setSize(width, height);
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.outputEncoding = THREE.sRGBEncoding;
      this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
      this.renderer.toneMappingExposure = 1.0;
      this.renderer.setClearAlpha(0); // 设置背景透明度为0

      //Three.js 的 renderer.domElement 有时会自动获取焦点，导致媒体行为异常。可以禁用
      this.renderer.domElement.tabIndex = -1; // 防止聚焦
      this.renderer.domElement.style.outline = 'none'; // 可选：隐藏轮廓

      this.$refs.threeContainer.appendChild(this.renderer.domElement);

      
      // 使用 DebugEnvironment
      const environment = new DebugEnvironment();
      const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
      this.scene.environment = pmremGenerator.fromScene(environment).texture;

      // // 添加轨道控制器（可选）
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      //是否可以缩放
      this.controls.enableZoom = true;
      //是否自动旋转
      this.controls.autoRotate = false;
      // //设置相机距离原点的最远距离
      // this.controls.minDistance = 1;
      // //设置相机距离原点的最远距离
      // this.controls.maxDistance = 10;
      //是否开启右键拖拽
      this.controls.enablePan = true;

      // 添加环境光
      const ambientLight = new THREE.AmbientLight(0xffffff, .3);
      this.scene.add(ambientLight);
      // 添加平行光
      const directionalLight = new THREE.DirectionalLight(0xffffff, .5);
      directionalLight.position.set(1,1,1);
      this.scene.add(directionalLight);


// 后处理
const composer = new EffectComposer(this.renderer);
const renderPass = new RenderPass(this.scene, this.camera);
composer.addPass(renderPass);

const outlinePass = new OutlinePass(
  new THREE.Vector2(width, height),
  this.scene,
  this.camera
);
// 设置边缘辉光效果
outlinePass.edgeStrength = 8.0;     // 发光强度（亮度）
outlinePass.edgeThickness = 8.0;    // 辉光宽度（越大越“胖”）
outlinePass.edgeGlow = 0.9;         // 模糊程度（0=锐利，1=非常模糊/柔和）
outlinePass.pulsePeriod = 0;       // 无脉冲（常亮）
// 可选：辉光颜色（更柔和的蓝色）
outlinePass.visibleEdgeColor.set(0x00aaff); // 浅蓝
outlinePass.hiddenEdgeColor.set(0x0066cc);  // 内部边缘颜色（可选）
composer.addPass(outlinePass);

// 添加 Bloom泛光 效果（让发光更明显）
const bloomPass = new UnrealBloomPass(
  new THREE.Vector2(width, height),
  1.0,   // 发光强度
  0.6,   // 模糊半径
  0.7    // 阈值
);
// 调高 threshold，只让最亮的部分泛光
bloomPass.threshold = 0.8;  // 只有亮度 > 80% 的才发光
bloomPass.strength = 1.5;
bloomPass.radius = 0.4;
// composer.addPass(bloomPass);

this.composer = composer
this.outlinePass = outlinePass
    },
    loadModel() {
      let that = this
      const gltfLoader = new GLTFLoader();
      let url = this.loft===1?'/assets/3d/一层模型.glb':'/assets/3d/二层模型.glb'
      // 加载 .glb 文件
      gltfLoader.load(
        url, 
        (gltf) => {
          // 模型加载成功
          console.log('模型加载成功:', gltf);
          const model = gltf.scene;
          if(this.loft===1){
            model.scale.set(0.4, 0.4, 0.4);
            model.position.set(-1,3.8,0)
          }else{
            model.scale.set(0.18, 0.18, 0.18);
            model.position.set(0,2,0)
          }
          model.rotation.y = - Math.PI / 2;
          model.rotation.x = 1

          const targetObjects = []; //边缘发光的物体
          model.traverse((child) => {
            if (child.isMesh) {
              that.clickableObjects.push(child);
              console.log(child.name)
              if (!child.name.startsWith('平面') && !child.name.startsWith('文本') && !child.name.startsWith('柱体') && !child.name.startsWith('箭头') && !child.name.startsWith('网格')) {
                child.material.emissive = child.material.emissive || new THREE.Color();
                  // child.material.color.set(0x548ecb);// 表面颜色（受光照）
                  child.material.emissive.set(0x548ecb);// 自发光（不受光照）
                  child.material.emissiveIntensity = 1;
                  targetObjects.push(child);
              }
            }
          });
          
        this.outlinePass.selectedObjects = targetObjects; // 设置辉光对象


          this.scene.add(model)
          this.model = model
          this.loading = false
          
          // 获取动画混合器
          const animations = gltf.animations;
          if (animations && animations.length) {
            this.mixer = new THREE.AnimationMixer(gltf.scene);
            for (let i = 0; i < animations.length; i++) {
              const action = this.mixer.clipAction(animations[i]);
              action.play();
            }
          }
        },
        (xhr) => {
          // 加载进度回调
          // console.log('模型加载进度:', (xhr.loaded / xhr.total * 100) + '% loaded');
        },
        (error) => {
          // 加载错误回调
          console.error('模型加载失败:', error);
        }
      );
    },
    // 不需要每帧都渲染（尤其是静态场景）：
    animate(time) {
      this.animationId = requestAnimationFrame(this.animate);
      // 限制渲染频率
      const TARGET_FPS = 30;
      if (time - this.lastRender < 1000 / TARGET_FPS) return;
      this.lastRender = time;

      // 更新动画
      if (this.mixer) {
        this.mixer.update(0.05);
      }
      // 更新控制器
      if (this.controls) {
        this.controls.update();
      }
      // 渲染场景
      this.renderer.render(this.scene, this.camera);
      if(this.loft===1){
        // 使用 composer 渲染（自动处理多 pass）
        this.composer.render();
      }
    },
    onClick(event) {
      const rect = this.renderer.domElement;
      const mouse = new THREE.Vector2(
        (event.offsetX / rect.clientWidth) * 2 - 1,
        -(event.offsetY / rect.clientHeight) * 2 + 1
      );
      // 设置射线
      const raycaster = new THREE.Raycaster()
      raycaster.setFromCamera(mouse, this.camera);
      raycaster.firstHitOnly = true;
      // 检测相交的对象，只考虑Mesh类型，并且限定为模型及其子对象
      const intersects = raycaster.intersectObjects(this.clickableObjects, true).filter(intersect => intersect.object instanceof THREE.Mesh);
      if (intersects.length > 0) {
        const target = intersects[0].object; // 代理对象
        console.log(target.name)
        if(target.name.indexOf('除尘器')>-1){
          this.$router.push('/info?type=xl&device=除尘器')
        }
        if(target.name.indexOf('储气罐')>-1){
          this.$router.push('/info?type=xl&device=储气罐')
        }
        if(target.name.indexOf('粉碎机组')>-1){
          this.$router.push('/info?type=xl&device=粉碎机组')
        }
        if(target.name.indexOf('干燥塔')>-1){
          this.$router.push('/info?type=xl&device=干燥塔')
        }
        if(target.name.indexOf('缓冲罐')>-1){
          this.$router.push('/info?type=xl&device=缓冲罐')
        }
        if(target.name.indexOf('混料机')>-1){
          this.$router.push('/info?type=xl&device=混料机')
        }
        if(target.name.indexOf('净乳机')>-1){
          this.$router.push('/info?type=xl&device=净乳机')
        }
        if(target.name.indexOf('空压机')>-1){
          this.$router.push('/info?type=xl&device=空压机')
        }
        if(target.name.indexOf('冷干机')>-1){
          this.$router.push('/info?type=xl&device=冷干机')
        }
        if(target.name.indexOf('螺旋输送机')>-1){
          this.$router.push('/info?type=xl&device=螺旋输送机')
        }
        if(target.name.indexOf('灭菌机')>-1){
          this.$router.push('/info?type=xl&device=灭菌机')
        }
        if(target.name.indexOf('凝乳罐')>-1){
          this.$router.push('/info?type=xl&device=凝乳罐')
        }
        if(target.name.indexOf('溶解罐')>-1){
          this.$router.push('/info?type=xl&device=溶解罐')
        }
        if(target.name.indexOf('湿法破碎机')>-1){
          this.$router.push('/info?type=xl&device=湿法破碎机')
        }
        if(target.name.indexOf('脱脂机')>-1){
          this.$router.push('/info?type=xl&device=脱脂机')
        }
        if(target.name.indexOf('压滤机')>-1){
          this.$router.push('/info?type=xl&device=压滤机')
        }
        if(target.name.indexOf('原料粉碎')>-1){
          this.$router.push('/info?type=xl&device=原料粉碎')
        }
        if(target.name.indexOf('自动包装机')>-1){
          this.$router.push('/info?type=xl&device=自动包装机')
        }
      }
    },
    onWindowResize() {
      const container = this.$refs.threeContainer;
      this.camera.aspect = container.clientWidth / container.clientHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(container.clientWidth, container.clientHeight);
    },
    cleanUp() {
      console.log("清理 Three.js 资源，防止内存泄漏")
      // 清理资源
      window.removeEventListener('resize', this.onWindowResize);
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
      if (this.controls) {
        this.controls.dispose();
        this.controls = null;
      }
      if (this.composer) {
        this.composer.renderTarget1.dispose();
        this.composer.renderTarget2.dispose();
        this.composer = null;
      }
      if (this.outlinePass) {
        if (this.outlinePass.renderTarget1) this.outlinePass.renderTarget1.dispose();
        if (this.outlinePass.renderTarget2) this.outlinePass.renderTarget2.dispose();
        this.outlinePass = null;
      }
      if(this.model){
        this.disposeModel(this.model)
        this.model = null
      }
      if (this.scene) {
        this.scene.clear();
        this.scene = null;
      }
      this.camera = null;
      if (this.renderer) {
        this.renderer.dispose();
        this.renderer.forceContextLoss();
        const canvas = this.renderer.domElement;
        if (canvas && canvas.parentNode) {
          canvas.parentNode.removeChild(canvas);
        }
        this.renderer = null;
      }
    },
    // 切换模型时销毁的 THREE.Mesh 或其父级 Group
    disposeModel(model) {
      // 遍历模型中的所有子对象
      model.traverse((child) => {
          if (child.isMesh) { // 如果是网格
              // 1. 释放几何体
              if (child.geometry) {
                  child.geometry.dispose();
              }
              // 2. 释放 material 和 textures
              if (child.material) {
                const materials = Array.isArray(child.material) ? child.material : [child.material];
                materials.forEach(mat => {
                  // 手动释放所有纹理
                  ['map', 'normalMap', 'emissiveMap', 'roughnessMap'].forEach(key => {
                    if (mat[key] && mat[key].isTexture) {
                      mat[key].dispose();
                    }
                  });
                  mat.dispose(); // 最后释放材质
                });
              }
          }
      });
      // 3. 从场景中移除该模型
      this.scene.remove(model);
    }
  },
};
</script>

<style lang="less" scoped>
@import '@/styles/subpage';
@import '@/styles/detail';
.chart{
  width: 100%;
  height: 100%;
}
.table{
  max-height: 100%;
  overflow: auto;
  padding-top: 10px;
  table{
    width: 100%;
    font-size: 24px;
  }
  th{
    color: #98e7fb;
  }
  td{
    text-align: center;
  }
}
.main{
  position: relative;
  .device{
    position: absolute;
    width: 140px;
    height: 170px;
    padding-top: 85px;
    text-align: center;
    span{
      font-weight: bold;
    }
  }
  .device0{
    left: 60px;
    top: 80px;
  }
  .device1{
    left: 288px;
    top: 80px;
  }
  .device2{
    left: 526px;
    top: 80px;
  }
  .device3{
    left: 60px;
    top: 344px;
  }
  .device4{
    left: 288px;
    top: 344px;
  }
  .device5{
    left: 526px;
    top: 344px;
  }
  .viewer{
    position: absolute;
    width: 200px;
    height: 200px;
    padding-top: 45px;
    text-align: center;
    // background: #000;
    // opacity: 0.5;
    span{
      font-weight: bold;
      color:#fff600;
    }
    p{
      color: #fff;
      margin-top: 60px;
    }
  }
  .viewer0{
    left: 63px;
    top: 23px;
  }
  .viewer1{
    left: 264px;
    top: 23px;
  }
  .viewer2{
    left: 455px;
    top: 23px;
  }
  .viewer3{
    left: 63px;
    top: 244px;
  }
  .viewer4{
    left: 264px;
    top: 244px;
  }
  .viewer5{
    left: 455px;
    top: 244px;
  }
}
.bjxx{
  .viewer0{
    left: 54px;
  }
  .viewer1{
    left: 255px;
  }
  .viewer2{
    left: 446px;
  }
  .viewer3{
    left: 54px;
    top: 255px;
  }
  .viewer4{
    left: 255px;
    top: 255px;
  }
  .viewer5{
    left: 446px;
    top: 255px;
  }
}
.top_bottom{
  .main{
    .device{
      width: 126px;
      height: 148px;
      padding-top: 72px;
      font-size: 26px;
    }
    .device0{
      left: 78px;
      top: 60px;
    }
    .device1{
      left: 282px;
      top: 60px;
    }
    .device2{
      left: 495px;
      top: 60px;
    }
    .device3{
      left: 78px;
      top: 266px;
    }
    .device4{
      left: 282px;
      top: 266px;
    }
    .device5{
      left: 495px;
      top: 266px;
    }
  }
}
.video{
  width: 100%;
  height: 100%;
}
</style>